import { render } from "./manage-applicants.vue?vue&type=template&id=12942c7c"
import script from "./manage-applicants.vue?vue&type=script&lang=js"
export * from "./manage-applicants.vue?vue&type=script&lang=js"

import "./manage-applicants.vue?vue&type=style&index=0&id=12942c7c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__